import { IconButton } from '@mui/material'
import Link from 'next/link'
import React, { ReactNode } from 'react'
import { SwapName } from '@/constants/token'
import { ReactComponent as UniswapSvg } from '@/assets/imgs/swap/uniswap.svg'
import { ReactComponent as PancakeSvg } from '@/assets/imgs/swap/pancake.svg'

const swapIconMap: Record<SwapName, ReactNode> = {
  uniswap: <UniswapSvg />,
  pancake: <PancakeSvg />,
}

const SwapLinkButton = ({ href, swap }: { href: string; swap: SwapName }) => {
  return (
    <Link href={href} target="_blank">
      <IconButton size="small">{swapIconMap[swap]}</IconButton>
    </Link>
  )
}

export default SwapLinkButton
